import { render, staticRenderFns } from "./ConsentGroupCreate.vue?vue&type=template&id=66d078a7&scoped=true&"
import script from "./ConsentGroupCreate.vue?vue&type=script&lang=js&"
export * from "./ConsentGroupCreate.vue?vue&type=script&lang=js&"
import style0 from "./ConsentGroupCreate.vue?vue&type=style&index=0&id=66d078a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d078a7",
  null
  
)

export default component.exports